<template>
    <div :class="['table', { 'expanded': plazos.data.length <= 3 }]">
        <b-table hover :items="plazos.data" :fields="fields" id="plazos-table">
            <template #cell(estado)></template>
            <template v-if="!sonAbonos" #cell(equipo)="{ item }">{{ item.equipo ? item.equipo : '' }}</template>
            <template #cell(importe)="{ item }">{{ item.importe | formatear_precio }}</template>
            <template #cell(price_management)="{ item }">{{ item.price_management | formatear_precio }}</template>
            <template #cell(opciones)="{ item, index }">
                <template v-if="!item.inactivo">
                    <OpcionesDropdownTableComponent 
                        v-if="item.estado == 4" 
                        :lastIndex="plazos.data.length > 3 && index >= plazos.data.length - 3"
                        v-bind:options="[
                            { type: 'action', action:() => showModal('aviso-plazo-' + item.id), label: 'Enviar aviso'},
                        ]"
                    />
                    <EnviarAviso :plazo_id="item.id" :loading="loading" :sonAbonos="sonAbonos" @close="closeModal" @terminado="enviarAviso(item.id)"></EnviarAviso>
                </template>
                <template v-else>
                    <Button disabled>Aviso enviado{{ sonAbonos ? '/Abono anulado' : '' }}</Button>
                </template>
            </template>
        </b-table>
    </div>
</template>

<script>
import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
import EnviarAviso from "../../backend/components/plazos/modals/EnviarAviso";

export default {
    props: ['plazos', 'sonAbonos'],
    data() {
        return {
            loading: false,
            fields: [
                { key: 'estado', label: '', tdClass: this.estaFallandoClass },
                { key: "fullName", label: "Nombre", class: 'text-center'},
                !this.sonAbonos ? { key: "equipo", label: "Equipo", class: 'text-center'} : {},
                { key: "email", label: "Email", class: 'text-center'},
                { key: "fecha", label: "Fecha Cobro", class: 'text-center' },
                { key: "importe", label: "Importe", class: 'text-center' },
                { key: "estado_string", label: "Estado", class: 'text-center' },
                { key: "error_string", label: "Tipo error", class: 'text-center'},
                { key: "email_fecha", label: "Fecha email enviado", class: 'text-center'},
                { key: "numPlazo", label: "Nº Plazo", class:'text-center'},
                { key: "opciones", label: "Opciones", class:'text-center'}
            ],
        }
    },
    methods: {
        estaFallandoClass(value, key, item) {
            switch (value) {
            case 0:
                return 'bg-secondary';

            case 1:
                return 'bg-green';

            case 2:
                return 'bg-dark';

            case 3:
                return 'bg-warning';

            case 4:
                return 'bg-red';

            case 5:
                return 'bg-black';

            default:
                return 'bg-red';
            }
        },
        enviarAviso(plazo_id) {
            this.loading = true;

            let params = {
                lista_id: this.lista.id,
                plazo_id: plazo_id,
                tipo: this.sonAbonos ? 'abonos' : 'bases'
            }

            this.$store.dispatch(this.config.getVuexAlias('back.plazos-impagados.enviar-aviso'), params).then(() => {
                this.$toast.success('Aviso enviado correctamente.');
                this.closeModal('aviso-plazo-' + plazo_id);
                this.$emit('actualizado');
            }).catch(error => {
                this.$toast.error('Ha ocurrido un error.');
            }).finally(() => this.loading = false);
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.$modal.hide(modal);
        }
    },
    computed: {
        lista() {
            return this.$store.getters.getListaActiva;
        }
    },
    components: {
        OpcionesDropdownTableComponent, EnviarAviso
    }
}

</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>